import React, { createContext, useState, useEffect } from 'react';
import specility from '../services/specility';
import { extractToken } from '../utils/localStorage';
 
export const SpecilityContext = createContext();
 
export const SpecilityProvider = ({ children }) => {
const [specialtyOptions, setSpecialtyOptions] = useState([]);
const token = extractToken();




useEffect(() => {

  fetchSpecialtyOptions();

}, []);
const fetchSpecialtyOptions = async () => {
  const response = await specility.getSpecialtiesList();

  setSpecialtyOptions(response?.data?.results?.map(item => ({
    label: item?.specialty,
    value: item?.specialty
  })));
};
  return (
    <SpecilityContext.Provider value={{ specialtyOptions, setSpecialtyOptions }}>
      {children}
    </SpecilityContext.Provider>
  );
};